import store from "../../js/lib/store";
import { mountWithElTemplate } from "../../js/lib/vue-mount";

const componentDefinition = {
  name: "header-cart-icon",
  methods: {
    toggleMiniCart() {
      store.toggleMiniCart();
    },
  },
  computed: {
    itemCount() {
      if (!store.cart) {
        return 0;
      }
      if (!store.cart.items) {
        return 0;
      }

      return (store.cart.items || []).reduce((count: number, item: any) => {
        count += Number(item.quantity);
        return count;
      }, 0);
    },
    itemCountText() {
      return `Your bag - ${this.itemCount} items`;
    },
  },
};

export default (el: HTMLElement) =>
  mountWithElTemplate(el, componentDefinition as any);
